import { createFileRoute } from '@tanstack/react-router';
import { RequirePermission } from '../../../features/layout/RequirePermission';
import { SettingsPage } from '../../../features/admin/settings/SettingsPage';

export const Route = createFileRoute('/_authed/admin/settings')({ component: Guarded });

function Guarded(): React.JSX.Element {
  return (
    <RequirePermission permission="settings.manage">
      <SettingsPage />
    </RequirePermission>
  );
}
